<template>
  <div>
    <span class="helloBn"><a @click="logout">安全退出</a></span>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  methods: {
    logout () {
      this.$confirm('确定退出？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          const api = '/md/front/user/logout'
          this.axios.post(api).then(res => {
            if (res.status === 200) {
              this.$store.commit('setGlobalObjOfNowUserLoginState', false)
              this.$message.success('退出成功')
              this.$router.push('/').catch(() => {}) // 让vue router帮我们进入目标组件
            }
          })
        })
        .catch(action => {})
    }
  }
}
</script>
<style scoped lang="less">
.helloBn {
   cursor: pointer;
   font-weight: 700;
   top: 5px;
   position: relative;
}

.helloBn a:hover {
  position: relative;
  top: 5px;
}
</style>
